export const refundStates = {
  waitApply: {
    value: '',
    name: '等待申请退款',
    tagType: 'info',
  },
  success: {
    value: 'SUCCESS',
    name: '退款成功',
    tagType: 'success',
  },
  notUsed: {
    value: 'CLOSED',
    name: '退款关闭',
    tagType: 'danger',
  },
  processing: {
    value: 'PROCESSING',
    name: '退款处理中',
    tagType: 'primary',
  },
  abnormal: {
    value: 'ABNORMAL',
    name: '退款异常',
    tagType: 'warning',
  },
};

export function findRefundState(refundStateValue) {
  for (const key in refundStates) {
    if (refundStateValue === refundStates[key].value) return [refundStates[key]];
  }
}

